<template>
    <div class="container">
        <van-nav-bar :title="activeDoc.DocName" left-text="返回" left-arrow safe-area-inset-top placeholder fixed @click-left="back" />
        <div class="title" v-if="!issingleton">
            <div style="font-size: 16px;text-align: left;">{{ activeItem && activeItem.lastupdatedt }}</div>
            <div class="actions">
                <van-button plain type="primary" v-show="activeDoc && activeDoc.children.length > 0" @click="popupShow = true">切换</van-button>
                <van-button plain type="primary" @click="handleCreate">新建</van-button>
            </div>
        </div>
        <div class="iframe-wrapper">
            <template v-if="this.isSurportHtml">
                <el-tag type="danger" size="mini" effect="light" style="position: absolute" v-if="changed">尚未保存</el-tag>
                <iframe ref="doc" :src="src" scrolling="yes" :srcdoc="srcdoc" id="resultpage" allow="microphone;camera;canvas" class="docframe" seamless></iframe>
            </template>

            <template v-else>
                <div style="padding: 10px 50px; opacity: 0.2; color: red; position: absolute; border: red; width: 50px; height: 50px; font-size: 50px; z-index: 1000" v-show="activeItem && activeItem.archiveddt && activeItem.archiveddt != ``">
                    <div>已归档</div>
                </div>
                <div class="docframe" :style="{ padding: '10px', 'min-height': `${this.screenHeight - 120}px` }">
                    <pdf v-for="i in numPages" :key="i" :src="src2" :page="i"></pdf>
                </div>
            </template>
        </div>
        <div class="footer">
            <van-button type="danger" v-show="activeItem && activeItem.docbizid" @click="handleDelete">删除</van-button>
            <van-button type="primary" @click="handleSave">保存</van-button>
        </div>

        <van-popup v-model="popupShow" closeable position="bottom" round>
            <div class="popup-content">
                <div class="popup-title">{{ activeDoc.DocName }}</div>
                <div class="items">
                    <div class="item" v-for="item in activeDoc.children" :key="item.docbizid" @click="handleChangeDoc(item)">
                        <span>{{ item.docname }}</span>
                        <van-icon name="success" :color="'var(--primary-color, #009688)'" v-if="+(activeItem && activeItem.docbizid) === +item.docbizid" />
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import myaxios from '@/myaxios.js'
import pdf from '@/common/vue-pdf-4.1.0'
import { mapGetters } from 'vuex'
import { NavBar as VanNavBar, Button as VanButton, Popup as VanPopup, Icon as VanIcon, Dialog, Toast } from 'vant'
export default {
    name: `DoucmentInfo`,
    components: {
        VanNavBar,
        VanButton,
        VanPopup,
        VanIcon,
        Toast
    },
    data() {
        window.addEventListener(
            `message`,
            event => {
                if (event.data.order == `aftersave`) {
                    if (event.data.type == 1) {
                        this.changed = false
                        Toast(`保存成功`)
                        this.refreshdoc()
                    }
                } else if (event.data.order == `changed`) {
                    this.changed = event.data.changed
                }
            },
            false
        )
        let sessionSurgeryObj = sessionStorage.getItem(`surgeryInfo`)
        let sessionSurgeryInfo = (sessionSurgeryObj && JSON.parse(sessionSurgeryObj)) || null
        let activeDocObj = sessionStorage.getItem(`activeDoc`)
        let activeDoc = activeDocObj && JSON.parse(activeDocObj) || null
        return {
            surgeryId: (this.$route.query.surgeryId && parseInt(this.$route.query.surgeryId)) || 0,
            surgeryInfo: sessionSurgeryInfo,
            activeDoc: activeDoc,
            activeItem: null,
            host: this.$root.DOCSERVICE_BASE,
            issingleton: activeDoc && activeDoc.issingleton, // 是否单例文书
            isSurportHtml: activeDoc && activeDoc.IsSurportHtml, // 是否可编辑文书
            hasChildren: activeDoc && activeDoc.hasChildren, // 是否有填写数据
            changed: false,
            loading: false,
            extraParams: {},
            docid: ``,
            isHide: ``,
            screenHeight: 0,
            numPages: [],
            popupShow: false,
            src: ``,
            srcdoc: ``
        }
    },
    created() {
        let that = this
        console.log(that.surgeryId)
        console.log(that.activeDoc)
    },
    computed: {
        ...mapGetters([`currentUser`])
    },
    mounted() {
        let that = this
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            that.loadInstances().then(() => {
                let clength = that.activeDoc.children.length
                if (clength > 0) {
                    that.activeItem = that.activeDoc.children[clength - 1]
                }
                that.loadDocument()
            })
        })
    },
    methods: {
        loadInstances() {
            let that = this
            return new Promise((resolve, reject) => {
                if (that.activeDoc && that.activeDoc.DocNo > 0 && that.activeDoc.hasChildren) {
                    let items = []
                    items.push({
                        docid: that.activeDoc.index,
                        issingleton: that.activeDoc.issingleton,
                        vid: that.surgeryId
                    })
                    let objs = {
                        dept: `acis2020`,
                        items: items
                    }
                    // 调用文书获取结果
                    let url = `${that.$root.DOCSERVICE_BASE}/Wth/QueryWTHMainData`
                    axios
                        .post(
                            url,
                            Qs.stringify(objs),
                            Object.assign({
                                emulateJSON: true
                            })
                        )
                        .then(res => {
                            if (res.Status == `SUCCESS`) {
                                let contents = res.Content
                                contents = _.filter(contents, f => {
                                    return f.istemplate == `0`
                                }).map(f => {
                                    f.index = `${f.docbizid}`
                                    f.docno = f.docno
                                    f.label = f.docname
                                    return f
                                })

                                let surgerydoc = _.filter(contents, item => item.vid == that.surgeryId)

                                let r = _.filter(surgerydoc, s => s.docno == that.activeDoc.DocNo)
                                if (r) {
                                    that.$set(that.activeDoc, `children`, r)
                                }
                            }
                            console.log(`activeDoc`)
                            console.log(that.activeDoc)
                            resolve(that.activeDoc)
                        })
                        .catch(e => {
                            console.log(e)
                        })
                }
            })
        },
        handleChangeDoc(item) {
            this.popupShow = false
            this.activeItem = item
            this.loadDocument()
        },
        handleDelete() {
            let that = this
            Dialog.confirm({
                title: `提示`,
                message: `确定要删除该文书实例吗？`
            })
                .then(() => {
                    if (this.activeItem.archiveddt && this.activeItem.archiveddt != ``) {
                        this.$message.error(`文书已归档，不能删除`)
                        return
                    }
                    let docbizid = that.activeItem.docbizid
                    let req = that.myaxios.get_doc(`Wth/DeleteInstance`, { docbizid: docbizid, operator: this.currentUser.dic_worker_id })
                    req.then(data => {
                        Toast(`删除成功`)
                        that.activeItem = undefined
                        that.loadInstances().then(() => {
                            that.activeItem = undefined
                            that.loadDocument()
                        })
                    })
                })
                .catch(() => {
                    // on cancel
                })
        },
        handleSave() {
            let that = this
            if (this.activeItem && this.activeItem.archiveddt && this.activeItem.archiveddt != ``) {
                return
            }
            that.save()
        },
        save() {
            let that = this
            let docno = this.activeDoc && this.activeDoc.DocNo
            let docbizid = this.activeItem && this.activeItem.docbizid
            if (docbizid > 0) {
                // 查询归档信息
                let req1 = myaxios.get_doc(`wth/QueryLastUpdateData?docbizid=${docbizid}`)
                req1.then(item => {
                    let wth = item.Content[0]
                    if (wth.creator && this.currentUser.dic_worker_name != wth.creator) {
                        this.$confirm(wth.creator + `于` + wth.lastupdatedt + `最后一次编辑，是否确认保存，保存后将覆盖?`, `提示`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`,
                            closeOnClickModal: false
                        }).then(() => {
                            if (docno) {
                                this.$refs.doc.contentWindow.postMessage({ order: `save` }, `*`)
                                window.localStorage.setItem(`savefalg`, `True`)
                            } else {
                                that.refreshdoc()
                            }
                        })
                    } else {
                        if (docno) {
                            this.$refs.doc.contentWindow.postMessage({ order: `save` }, `*`)
                            window.localStorage.setItem(`savefalg`, `True`)
                        } else {
                            that.refreshdoc()
                        }
                    }
                })
            } else {
                if (docno) {
                    this.$refs.doc.contentWindow.postMessage({ order: `save` }, `*`)
                    window.localStorage.setItem(`savefalg`, `True`)
                } else {
                    that.refreshdoc()
                }
            }
        },
        refreshdoc() {
            let that = this
            that.loadInstances().then(() => {
                if (!that.activeItem) {
                    let clength = that.activeDoc.children.length
                    if (clength > 0) {
                        that.activeItem = that.activeDoc.children[clength - 1]
                    }
                }
                console.log(`refreshdoc`)
                console.log(that.activeItem)
                that.loadDocument()
            })
        },
        handleCreate() {
            this.activeItem = null
            this.loadDocument()
        },
        back() {
            this.$router.push({ name: `SurgeryDetail`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, activeTab: `doc` } }).catch(err => err)
        },
        generateUUID() {
            var d = new Date().getTime()
            var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16) % 16 | 0
                d = Math.floor(d / 16)
                return (c == `x` ? r : (r & 0x3) | 0x8).toString(16)
            })
            return uuid
        },
        loadDocument() {
            let that = this
            if (!this.activeDoc.DocNo) {
                this.$message.warning(`请配置相关文书`)
                return
            }
            this.loading = true
            // 可编辑文书
            if (this.activeDoc.IsSurportHtml) {
                this.loadInstance(that.activeDoc.DocId, that.activeItem)
            } else {
                // 只读文书
                this.$store
                    .dispatch(`LOAD_PDF_DATA`, {
                        host: this.host,
                        params: Object.assign(
                            {
                                docid: this.activeDoc.DocNo,
                                from: this.$moment().format(`YYYYMMDDHHmm`),
                                to: this.$moment().format(`YYYYMMDDHHmm`),
                                id1: this.surgeryId,
                                id3: 1
                            },
                            this.extraParams
                        )
                    })
                    .then(data => {
                        this.src2 = pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
                        this.src2.then(content => {
                            this.numPages = content.numPages
                            this.loading = false
                        })
                    })
                    .catch(e => {
                        console.log(e)
                        this.loading = false
                    })
            }
        },
        loadInstance(docid, item) {
            this.changed = false
            axios
                .get(`${this.host}/doc3.ashx/wth`, {
                    params: Object.assign(
                        {
                            vid: this.surgeryId,
                            from: this.$moment().format(`YYYYMMDDHHmm`),
                            to: this.$moment().format(`YYYYMMDDHHmm`),
                            dept: `acis2020`,
                            operator: this.currentUser.dic_worker_name,
                            username: this.currentUser.dic_worker_id,
                            catoken: sessionStorage.getItem(`caToken`),
                            templateid: ``,
                            strategy: `UF`,
                            guid: (item && item.docguid) || this.generateUUID(),
                            docid: docid,
                            docname: this.activeDoc.docname,
                            docbizid: item && item.docbizid,
                            singleton: this.activeDoc && this.activeDoc.issingleton // 是否单例文书
                        },
                        this.extraParams
                    )
                })
                .then(res => {
                    if (res.Status == `SUCCESS`) {
                        this.docid = res.DocId || docid
                        this.srcdoc = undefined
                        this.src = res.TargetUrl + `?r=` + Math.random()
                    } else {
                        console.error(`load instance failed.${res.Content}`)
                        this.srcdoc = res.Content
                    }
                    this.loading = false
                })
                .catch(e => {
                    this.loading = false
                    console.log(e)
                })
        }
    },
    beforeDestroy() {},
    watch: {}
}
</script>
<style lang="less" scoped>
.container {
    --theme-color: var(--primary-color, #009688);
    height: 100vh;
    display: flex;
    flex-direction: column;
    /deep/ .van-nav-bar {
        background-color: var(--theme-color);
        .van-nav-bar__text,
        .van-icon,
        .van-nav-bar__title {
            color: #fff;
        }
    }
    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 46px;
        padding: 0 16px;
        .actions {
            display: flex;
            align-items: center;
            gap: 10px;
            .van-button {
                width: 45px;
                height: 28px;
                padding: 0;
                font-size: 14px;
                color: var(--theme-color);
                border: 1px solid var(--theme-color);
                border-radius: 4px;
            }
        }
    }
    .iframe-wrapper {
        flex: 1;
        height: 0;
        .docframe {
            height: 100%;
            width: 100%;
            border: none;
        }
    }
    .footer {
        height: 58px;
        border-top: 1px solid rgba(#e5e5e5, 0.5);
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 16px;
        gap: 16px;
        .van-button {
            width: 72px;
            height: 42px;
            border-radius: 4px;
            font-size: 16px;
            border: none;
            line-height: 42px;
            &.van-button--danger {
                background-color: #fff1f0;
                color: #ff3141;
            }
            &.van-button--primary {
                background: linear-gradient(179deg, #0ed1a4 0%, var(--theme-color) 100%);
                color: #fff;
            }
        }
    }

    .popup-content {
        min-height: 30vh;
        .popup-title {
            height: 22px;
            margin: 16px 0;
            text-align: center;
            font-weight: bold;
            width: 100%;
            font-size: 16px;
        }
        .items {
            .item {
                border-bottom: 1px solid rgba(#e5e5e5, 0.5);
                height: 44px;
                padding: 0 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 16px;
                &:last-child {
                    border-bottom: none;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile/DoucmentInfo.vue